/**
 * Context Hook (useContext)
 */

import { useContext } from "react";
import RefreshContext from "./Refresh.context";
export const RefreshHook = () => useContext(RefreshContext)
